// extracted by mini-css-extract-plugin
export default {"Container":"ModalBody_Container__s8jWh"};